/* eslint-disable no-await-in-loop */
/* eslint-disable no-lonely-if */
/* eslint-disable no-else-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable consistent-return */
/* eslint-disable func-names */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable no-plusplus */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import { isDefined } from 'class-validator';
import React, { useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from 'src/app/components/MapComponent/plugins/EteMapExport/EteMapExport.module.scss';
import { mergeImages } from 'merge-base64';
// @ts-ignore
import { useScreenshot } from 'use-react-screenshot';
import moment from 'moment';
import domtoimage from 'dom-to-image-more';
import { RiEarthLine, RiCheckboxMultipleBlankFill } from 'react-icons/ri';
import { BiCrop } from 'react-icons/bi';
import { TbReportAnalytics } from 'react-icons/tb';
import { IoMdDownload } from 'react-icons/io';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { reduxRootTypes } from 'src/types';
import { getStore } from 'src/app/redux/store';
import { DomToImageOptionsType, EteMapExportPropsType } from './ete-map-export.config';
import Tooltip from 'antd/es/tooltip';

// Return Component
export const EteMapExport: React.FC<EteMapExportPropsType> = ({
  generateMapImage,
  generateSitrepMisrepBarImages,
  screenShotBoth,
  setCropActive,
  canExportSitrepMisrep,
}) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div className={styles.container} onMouseLeave={() => setIsHover(false)} id="ete-map-export-plugin">
      <div onMouseOver={() => setIsHover(true)}>
        <IoMdDownload className={styles.button} size={20} />
      </div>
      {isHover && (
        <div className={styles.rightContainer}>
          <div>
            <Tooltip placement="top" title="Map">
              <RiEarthLine size={20} onClick={() => generateMapImage(true)} className={styles.button} />
            </Tooltip>
          </div>

          {/* {canExportSitrepMisrep && (
            <>
              <div>
                <Tooltip placement="bottom" title="Sitrep/Misrep Bars">
                  <TbReportAnalytics
                    className={styles.button}
                    size={20}
                    onClick={() => generateSitrepMisrepBarImages(true)}
                  />
                </Tooltip>
              </div>
              <div>
                <Tooltip placement="bottom" title="All">
                  <RiCheckboxMultipleBlankFill className={styles.button} size={20} onClick={screenShotBoth} />
                </Tooltip>
              </div>
            </>
          )} */}

          <div>
            <Tooltip placement="bottom" title="Crop on Map">
              <BiCrop className={styles.button} size={20} onClick={setCropActive} />
            </Tooltip>
          </div>
        </div>
      )}
    </div>
  );
};

// Logic Component
const EteMapExportLogic: React.FC<{
  Comp: React.FC<EteMapExportPropsType>;

  setCropActive: () => void;
  setImageCropUrl: (str: string) => void;
  canExportSitrepMisrep: boolean;
}> = ({ Comp, setCropActive, setImageCropUrl, canExportSitrepMisrep }) => {
  const dispatch = useDispatch();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [image, takeScreenshot] = useScreenshot();

  const { sitrepSelectedUnits } = useSelector((state: reduxRootTypes.RootStateType) => state.unitsState);
  const { activeTabs } = useSelector((state: reduxRootTypes.RootStateType) => state.mapState);

  const misrepSelectedUnits = useMemo(
    () =>
      sitrepSelectedUnits
        .filter((o) => o.isMisrepOpen && o.misrepDetails !== undefined)
        .flatMap((o) => {
          if (o.misrepDetails) {
            return [o.misrepDetails];
          }
          return [];
        }),
    [sitrepSelectedUnits],
  );

  const mergeAndDownloadBase64Images = async (arr: string[]) => {
    try {
      const mergedImage = await mergeImages(arr);
      if (isDefined(mergedImage)) {
        const link = document.createElement('a');
        link.href = mergedImage;
        document.body.appendChild(link);
        link.style.display = 'none';
        link.target = '_blank';
        link.setAttribute('download', `hymots-c/${moment().format('DD/MM/YYYY hh:mm')}`);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Screen Shot Failed');
    }
  };

  const generateSitrepMisrepBarImages = async (forceDownload: boolean) => {
    const localArray: string[] = [];
    if (activeTabs.sitrep) {
      for (let i = 0; i < sitrepSelectedUnits.length; i += 1) {
        if (sitrepSelectedUnits[i].isVisible) {
          const elem = document.getElementById(`sitrep_${sitrepSelectedUnits[i].id}`);
          if (isDefined(elem)) {
            const loc: string = await takeScreenshot(elem);
            localArray.push(loc.split(',')[1]);
          }
        }
      }
    }
    if (activeTabs.misrep && misrepSelectedUnits) {
      for (let i = 0; i < misrepSelectedUnits.length; i += 1) {
        if (misrepSelectedUnits[i].isVisible) {
          const elem = document.getElementById(`misrep${misrepSelectedUnits[i].id}`);
          if (isDefined(elem)) {
            const loc: string = await takeScreenshot(elem);
            localArray.push(loc.split(',')[1]);
          }
        }
      }
    }

    if (forceDownload) {
      if (localArray.length) {
        mergeAndDownloadBase64Images(localArray);
      } else {
      }
    } else return localArray;
  };

  const generateMapImage = async (forceDownload: boolean, forCrop?: boolean) => {
    const etePlugin = document.getElementById('ete-map-export-plugin');
    if (etePlugin) {
      etePlugin.style.visibility = 'hidden';
    }

    const elem = document.getElementById('map');

    if (elem) {
      const options: DomToImageOptionsType = {
        quality: 1,
        width: elem.offsetWidth,
        height: elem.offsetHeight,
        imagePlaceholder: 'hymots-c Export Error',
      };

      return domtoimage
        .toPng(elem, options)
        .then(function (dataUrl: any) {
          if (forceDownload) {
            if (etePlugin) {
              etePlugin.style.visibility = 'visible';
            }
            const link = document.createElement('a');
            link.href = dataUrl;
            document.body.appendChild(link);
            link.style.display = 'none';
            link.target = '_blank';
            link.setAttribute('download', `hymots-c/${moment().format('DD/MM/YYYY hh:mm')}`);
            link.click();
            document.body.removeChild(link);
          } else {
            if (forCrop) {
              if (etePlugin) {
                etePlugin.style.visibility = 'visible';
              }

              return dataUrl;
            } else {
              if (etePlugin) {
                etePlugin.style.visibility = 'visible';
              }
              return dataUrl.split(',')[1];
            }
          }
        })
        .catch(function (error: any) {
          if (etePlugin) {
            etePlugin.style.visibility = 'visible';
          }

          // eslint-disable-next-line no-console
          console.error('Screenshot Error', error);
        });
    } else {
    }
  };
  const screenShotBoth = async () => {
    const mapImage = await generateMapImage(false);
    const barImages = await generateSitrepMisrepBarImages(false);
    if (mapImage) {
      if (barImages) {
        mergeAndDownloadBase64Images([mapImage, ...barImages]);
      } else {
        generateMapImage(true);
      }
    }
  };

  const cropOnMap = async () => {
    const mapImage = await generateMapImage(false, true);
    setImageCropUrl(mapImage);
    setCropActive();
  };

  return (
    <Comp
      generateSitrepMisrepBarImages={generateSitrepMisrepBarImages}
      generateMapImage={generateMapImage}
      screenShotBoth={screenShotBoth}
      setCropActive={cropOnMap}
      canExportSitrepMisrep={canExportSitrepMisrep}
    />
  );
};

export interface EteMapExportProps extends L.ControlOptions {
  customComponent?: React.FunctionComponent<EteMapExportPropsType>;
  setCropActive: () => void;
  setImageCropUrl: (str: string) => void;
  canExportSitrepMisrep: boolean;
}

export class EteMapExp extends L.Control {
  element: HTMLElement | null;

  Comp: React.FC<EteMapExportPropsType>;

  setCropActive: () => void;

  setImageCropUrl: (str: string) => void;

  canExportSitrepMisrep: boolean;

  constructor(options: EteMapExportProps) {
    super(options);

    this.element = null;

    this.Comp = options.customComponent || EteMapExport;

    this.setCropActive = options.setCropActive;
    this.setImageCropUrl = options.setImageCropUrl;
    this.canExportSitrepMisrep = options.canExportSitrepMisrep;
  }

  onAdd = () => {
    this.element = L.DomUtil.create('div', 'leaflet-control-scale');
    ReactDOM.render(
      <Provider store={getStore()}>
        <EteMapExportLogic
          Comp={this.Comp}
          setCropActive={this.setCropActive}
          setImageCropUrl={this.setImageCropUrl}
          canExportSitrepMisrep={this.canExportSitrepMisrep}
        />
      </Provider>,
      this.element,
    );
    L.DomEvent.disableClickPropagation(this.element);
    L.DomEvent.on(this.element, 'mousedown', L.DomEvent.stopPropagation);
    L.DomEvent.on(this.element, 'mouseup', L.DomEvent.stopPropagation);
    L.DomEvent.on(this.element, 'dblclick', L.DomEvent.stopPropagation);
    return this.element;
  };

  // eslint-disable-next-line class-methods-use-this
  onRemove = () => {};
}
